import omit from "lodash-es/omit";
import { useRouter } from "next/router";
export const useAddRemoveQuery = (key: string) => {
  const router = useRouter();
  const removeQuery = () => {
    const remainingQuery = omit(router.query, [key]);
    return router?.replace({
      pathname: router?.pathname,
      query: remainingQuery
    }, undefined, {
      shallow: true,
      scroll: false
    });
  };
  const addQuery = (query: string) => {
    const {
      [key]: q
    } = router.query;
    if (q) {
      removeQuery()?.finally(() => router?.replace({
        pathname: router?.pathname,
        query: {
          ...router?.query,
          [key]: query
        }
      }, undefined, {
        shallow: true,
        scroll: false
      }));
    }
    return router?.push({
      pathname: router?.pathname,
      query: {
        ...router?.query,
        [key]: query
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
  };
  return {
    addQuery,
    removeQuery
  };
};